import { Card, CardContent, CardHeader, Divider, Paper, Typography, Avatar, Box } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { taskHistoryRequest } from '../../store/actions';
import { text } from '../../modules/languages/index';
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import PersonIcon from '@material-ui/icons/Person';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0),
  },
  card: {
    boxShadow: "none", // Gölge kaldırıldı
    border: "1px solid #e0e0e0", // Gölge yerine ince bir çerçeve eklendi
  },
  header: {

    '& .MuiCardHeader-title': {
      fontSize: '1rem',
      fontWeight: 'bold',
    }
  },
  paper: {
    padding: '12px',

    backgroundColor: '#fafafa',
    borderLeft: '4px solid #FF9800',
    marginBottom: theme.spacing(1),
    boxShadow: "none", // İç kağıt gölgesi kaldırıldı
    border: "1px solid #eee",
  },
  timeBox: {
    minWidth: '75px',
    padding: '8px 0',
  },
  dateText: {
    fontWeight: 700,
    color: '#424242',
    fontSize: '0.8rem',
    lineHeight: 1.2
  },
  timeText: {
    color: '#757575',
    fontSize: '0.7rem',
  },
  statusTitle: {
    color: '#FF9800',
    fontWeight: 'bold',
    fontSize: '0.9rem',
    marginBottom: 6,
    textTransform: 'uppercase'
  },
  contentBody: {
    fontSize: '0.85rem',
    color: '#333',
    lineHeight: 1.5,
    wordBreak: 'break-word',
  },
  technicianBox: {
    marginTop: 10,
    display: 'flex',
    alignItems: 'center',
    padding: '6px 10px',
    backgroundColor: '#424242', // Teknisyen alanı marka renginizle belirginleştirildi
    borderRadius: 6,
    color: '#FF9800',
    fontSize: '0.8rem',
    fontWeight: 'bold'
  }
}));

function History({ className, FisNo, taskHistoryReducer, taskHistoryRequest }) {
  const classes = useStyles();

  useEffect(() => {
    taskHistoryRequest(FisNo);
  }, [FisNo, taskHistoryRequest]);

  return (
    <div className={clsx(classes.root, className)}>
      <Card className={classes.card}>
        <CardHeader 
          className={classes.header}
          title={text("Fis_Tarihce")} 
        />
        <Divider />
        
        {taskHistoryReducer.loading && (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress style={{ color: '#FF9800' }} />
          </Box>
        )}

        <CardContent style={{ padding: '8px 0px' }}>
          <Timeline align="left" style={{ padding: '0 8px' }}>
            {taskHistoryReducer.data.map((log, index) => (
              <TimelineItem key={index}>
                
                <TimelineOppositeContent className={classes.timeBox} style={{ flex: 0.1, paddingRight: 8, paddingLeft: 0 }}>
                  <Typography className={classes.dateText}>
                    {`${log.GUN} ${log.AY.substring(0, 3)}`}
                  </Typography>
                  <Typography className={classes.timeText}>
                    {log.SAAT}
                  </Typography>
                </TimelineOppositeContent>

                <TimelineSeparator>
                  <Avatar style={{
                    backgroundColor: '#424242',
                    color: '#FF9800',
                    width: 26, height: 26, fontSize: 12, fontWeight: 'bold'
                  }}>
                    {taskHistoryReducer.data.length - index}
                  </Avatar>
                  {index !== taskHistoryReducer.data.length - 1 && (
                    <TimelineConnector style={{ backgroundColor: '#FF9800', width: 2 }} />
                  )}
                </TimelineSeparator>

                <TimelineContent style={{ paddingRight: 0, paddingLeft: 10, paddingBottom: 20 }}>
                  <Paper className={classes.paper}>
                    <Typography className={classes.statusTitle}>
                      {log.DURUM}
                    </Typography>
                    
                    <Typography className={classes.contentBody} component="div">
                      {log.BASVURU_NOTU && (
                        <Box mb={1}>
                          <span style={{fontWeight: 600}}>Başvuru:</span> {log.BASVURU_NOTU}
                        </Box>
                      )}
                      {log.SONUC_NOTU && (
                        <Box>
                          <span style={{fontWeight: 600}}>Sonuç:</span> {log.SONUC_NOTU}
                        </Box>
                      )}
                    </Typography>

                    {/* Teknisyen Bilgisi Vurgulandı */}
                    <div className={classes.technicianBox}>
                      <PersonIcon style={{ fontSize: 16, marginRight: 5 }} />
                      {log.ISLEM_YAPAN || "Sistem"} : {log.KULLANICI}
                    </div>
                  </Paper>
                </TimelineContent>

              </TimelineItem>
            ))}
          </Timeline>
        </CardContent>
      </Card>
    </div>
  );
}

History.propTypes = {
  className: PropTypes.string
};

export default connect(
  (state) => ({
    taskHistoryReducer: state.taskHistoryReducer,
  }),
  { taskHistoryRequest }
)(History);